<div class="container-idle">
	<div class="modal" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h1>Crea un pedido</h1>
					<h1 style="left: 0;" class="i-hover"><i class="fa fa-xmark" (click)="close.emit(false)"></i></h1>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-sm-3 form-group">
							<label for="date" class="form-label">Fecha<span
								class="required">*</span></label>
							<input type="date" [ngModel]="date | date:'yyyy-MM-dd'" (ngModelChange)="date = $event"
								name="date" id="date" class="form-control">
						</div>
						<div class="col-sm-3 form-group">
							<label for="warehouse-order" class="form-label">Bodega<span
								class="required">*</span></label>
							<div class="input-group">
								<app-input-autocomplete [allBorderRadius]="true" [inputs]="inputs.warehouse"
									[placeholder]="'Ingresa una bodega'" [filterElements]="filterWarehouses"
									[typeElements]="'warehouse-order'" (inputMethod)="writeWarehouse($event.event)"
									(changeStatus)="checkWarehouse($event.filterElement)"
									(getTitle)="$event.filterElement.title = $event.filterElement.name"></app-input-autocomplete>
							</div>
						</div>
						<div class="col-sm-3 form-group">
							<label for="product-order" class="form-label">Producto</label>
							<div class="input-group">
								<app-input-autocomplete [allBorderRadius]="true" [inputs]="inputs.product"
									[placeholder]="'Ingresa un producto'" [filterElements]="filterProducts"
									[typeElements]="'product-order'" (inputMethod)="writeProduct($event.event)"
									(changeStatus)="checkProduct($event.filterElement)"
									(getTitle)="$event.filterElement.title = $event.filterElement.code+  ' - '+ $event.filterElement.name"></app-input-autocomplete>
							</div>
						</div>
						<div class="col-sm-3 form-group">
							<label for="ammount" class="form-label">Cantidad</label>
							<div class="input-group">
								<input type="number" name="ammount" id="ammount" [(ngModel)]="quantity"
									class="form-control">
								<button class="btn btn-primary" (click)="addProduct()" title="Agregar producto" [disabled]="!inputs.product.verified || quantity <= 0">
									<span class="superposition-container">
										<i class='fa fa-boxes'></i>
										<i style="color: yellow;" class="fa fa-plus superposition-element"></i>
									</span>
								</button>
							</div>
						</div>
					</div>
					<div class="row" *ngIf="productList.length > 0">
						<div class="col">
							<div class="table-responsive" style="max-height: 200px;">
								<table class="table table-striped">
									<thead>
										<tr>
											<th colspan="4">Producto</th>
											<th class="td-center">Cantidad</th>
											<th class="td-center">Opciones</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let product of productList; let i = index">
											<td colspan="4">{{product.productData.name}}</td>
											<td class="td-center">{{product.quantity}}</td>
											<td class="td-center">
												<div style="display: flex; justify-content: space-evenly;">
													<span class="clickeable text-danger" (click)="deleteProductFromList(i)">
														<i class="fa fa-trash"></i>
													</span>
												</div>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
					<p class="text-muted" style="margin-top: 1em; font-size: 0.8em; text-align: right;"><i
							class="fa fa-circle-info"></i>Completa los campos marcados con un <span
							class="required">*</span> y agrega productos para crear el pedido</p>
				</div>
				<div class="modal-footer">
					<button class="btn btn-success" (click)="createOrder()"
					 [disabled]="loading || !inputs.warehouse.verified || !date || productList.length == 0">
						<ng-container *ngIf="!loading">
							<i class="fa fa-floppy-disk"></i>
						</ng-container>
						<ng-container *ngIf="loading">
							<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
							<span role="status"></span>
						</ng-container>GUARDAR
					</button>
				</div>
			</div>
		</div>
	</div>
</div>